import React, { VFC } from 'react';
import { Theme, useTheme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';
import Title from '~/src/feature/toyono/components/Title';
import { Covid19Button } from '../../covid19';
import LargeButton from './LargeButton';
import { BUSINESSES } from '../../routing';
import BusinessCard from '../../../front/Businesses/Card';
import PlanCard from '../../../front/Plans/Card';
import Typography from '@material-ui/core/Typography';
import { BusinessProps, PlanProps } from '~/src/feature/toyono/types';

const useStyles = makeStyles((theme) => ({
  grid: {
    textAlign: 'left',
  },
  subtitle: {
    fontWeight: 'bold',
    fontSize: 20,
    margin: theme.spacing(4, 0, 2),
    textAlign: 'left',
  },
}));

const Container = styled.div<{ theme: Theme }>`
  width: 100%;
  margin: auto;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 1200px;
  }
`;

const ButtonContainer = styled.div`
  text-align: center;
  max-width: 500px;
  margin: auto;
  padding: ${({ theme }) => theme.spacing(4, 0)};
`;

const TitleWrapper = styled.div`
  text-align: center;
`;

interface Props {
  authenticated: boolean;
  businesses: Array<BusinessProps>;
  plans: Array<PlanProps>;
}

const Plan: VFC<Props> = ({ businesses, plans, authenticated }: Props) => {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Container theme={theme}>
      <TitleWrapper>
        <Title text="OTETSUTABI">豊能町のおてつたび</Title>
      </TitleWrapper>
      {plans.length > 0 && (
        <Typography variant="h3" className={classes.subtitle}>
          現在募集中の豊能町のおてつたび
        </Typography>
      )}
      <Grid container spacing={2}>
        {plans.map((plan, idx) => (
          <Grid item xs={6} sm={4} md={3} key={idx}>
            <PlanCard {...plan} isAuthenticated={authenticated} />
          </Grid>
        ))}
      </Grid>
      {businesses.length > 0 && (
        <Typography variant="h3" className={classes.subtitle}>
          すべての豊能町のおてつたび先
        </Typography>
      )}
      <Grid container alignItems="center" spacing={2} className={classes.grid}>
        {businesses.map((business, idx) => (
          <Grid item xs={6} sm={4} md={3} key={idx}>
            <BusinessCard {...business} />
          </Grid>
        ))}
      </Grid>
      <ButtonContainer theme={theme}>
        <LargeButton href={BUSINESSES + '?feature=toyono'}>
          おてつたび先一覧はこちら
        </LargeButton>
        <Covid19Button />
      </ButtonContainer>
    </Container>
  );
};

export default Plan;
